export const CIAN_PRO_RS_KEY = 'cianProExperimentName';

export enum ECianProGroups {
  disabled = 'disabled',
  enabled = 'enabled',
}
